import React from 'react';
import type { FC } from 'react';
import { getNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';
import { useIterator } from '@alfa-bank/site-form-iterator/context';

import type { IProps } from './models';
import { isEmpty } from './helpers/is-empty';

export const FormNamedContainer: FC<IProps> = ({ children, context, name }) => {
    const { children: child, ...namedContainers } = getNamedContainersWithChildren(children);
    const key = useIterator<keyof typeof namedContainers>({ context, name });

    /** children будет показывать по умолчанию при отсутствии namedContainers */
    const content = namedContainers[key] ? namedContainers[key] : child;

    return isEmpty(key) ? null : <>{content}</>;
};
